import React from "react";

import { TooltipProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BsInfoCircle } from "react-icons/bs";

import useStyles from "./styles";

export const ssccPrerequisitesTooltipSlotProps: TooltipProps["slotProps"] = {
  tooltip: {
    sx: {
      maxWidth: 380,
      padding: "8px 12px",
    },
  },
};

interface Props {
  translationKeys: string[];
}

const SSCCPrerequisitesTooltip = ({ translationKeys }: Props) => {
  const { t: translate } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.tooltipContainer}>
      {translationKeys.map((key) => (
        <div key={key} className={classes.tooltipTitle}>
          <BsInfoCircle className={classes.tooltipIcon} />
          <span className={classes.tooltipText}>{translate(key)}</span>
        </div>
      ))}
    </div>
  );
};

export default SSCCPrerequisitesTooltip;
